import React, { useState } from "react";

const withHardReload = WrappedComponent => props => {
  const [key, setKey] = useState(0);

  const reload = () => {
    setKey(k => k + 1);
  };

  return <WrappedComponent {...props} key={key} hardReload={reload} />;
};

export default withHardReload;
